const valuesMustMatch = (value1, value2) => {
  if (value1.length === 0) {
    return true;
  }
  return value1 === value2;
};
export default valuesMustMatch;
